
import React, { useState, useEffect } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import { v4 as uuidv4 } from "uuid";
import { Helmet } from "react-helmet";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Divider,
  Box,
  Snackbar,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Dashboard from "./../../Components/Dashboard/Dashboard.css";

const CompanyRegistrationForm = () => {
  const [formData, setFormData] = useState({
    establishmentid: "",
    establishmentnumber: "",
    establishmentdescription: "",
    website: "",
    emailid: "",
    ephonenumber: "",
    address1: "",
    city: "",
    state: "",
    pincode: "",
    contactpersonname: "",
    contactpersonemailid: "",
    industrytype: "",
    registrationdate: null,
    amountpaid: "",
    paymentdetails: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);

  const generateUniqueID = () => {
    return `CT-${uuidv4()}`;
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      establishmentid: generateUniqueID(),
    }));
  }, []);

  const [errors, setErrors] = useState({
    emailid: false,
    ephonenumber: false,
    contactpersonname: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validation regex patterns
    const emailRegex = /^\S+@\S+\.\S+$/;
    const phoneRegex = /^[0-9]{10}$/;

    setFormData({
      ...formData,
      [name]: value,
    });
    // Exclude setting registrationdate in handleChange
    if (name !== "registrationdate") {
      setFormData({
        ...formData,
        [name]: value,
      });
      // Clear the specific error when the user starts typing in a field
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]:
          name === "emailid"
            ? !emailRegex.test(value)
            : name === "ephonenumber"
            ? !phoneRegex.test(value)
            : false,
      }));
    }
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      registrationdate: date,
    });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check required fields and set error state if empty
    const requiredFields = ["emailid", "ephonenumber", "contactpersonname"];
    let hasError = false;
    const updatedErrors = { ...errors };
    requiredFields.forEach((field) => {
      if (formData[field].trim() === "") {
        updatedErrors[field] = true;
        hasError = true;
      } else {
        updatedErrors[field] = false;
      }
    });

    if (hasError) {
      setErrors(updatedErrors);
      return;
    }

    // Check if amountpaid is empty and convert it to an empty string if needed
    const amountPaidValue =
      formData.amountpaid.trim() === ""
        ? null
        : parseFloat(formData.amountpaid);

    try {
      const response = await axiosInstance.post("/api/addCompanyRegistration", {
        ...formData,
        amountpaid: amountPaidValue,
      });

      if (response.status === 201) {
        setSuccessMessage("Form submitted successfully!");
        setOpenSuccess(true);

        // Hide the success message after 3 seconds (adjust duration as needed)
        setTimeout(() => {
          setOpenSuccess(false);
          setSuccessMessage("");
        }, 3000);

        setFormData({
          establishmentid: "",
          establishmentnumber: "",
          establishmentdescription: "",
          website: "",
          emailid: "",
          ephonenumber: "",
          address1: "",
          city: "",
          state: "",
          pincode: "",
          contactpersonname: "",
          contactpersonemailid: "",
          industrytype: "",
          registrationdate: null,
          amountpaid: "",
          paymentdetails: "",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  // return (
  //   <>
  //     <Helmet>
  //       <title>ContactTab | Establishment Registration</title>
  //     </Helmet>
  //     <form onSubmit={handleSubmit}>
  //       <Grid
  //         container
  //         spacing={3}
  //       >
  //         {/* Establishment Registration Heading */}
  //         <Grid
  //           container
  //           item
  //           xs={12}
  //         >
  //           <Grid
  //             item
  //             xs={8}
  //           >
  //             <Typography
  //               variant="h5"
  //               align="left"
  //             >
  //               Establishment Registration
  //             </Typography>
  //           </Grid>
  //           <Grid
  //             item
  //             xs={4}
  //             className="text-end"
  //           >
  //             {/* <EditIcon /> */}
  //           </Grid>
  //         </Grid>

  //         {/* Establishment Details */}

  //         {/* Divider line */}
  //         <Grid
  //           item
  //           xs={12}
  //         >
  //           <Box>
  //             <Divider
  //               variant="fullWidth"
  //               style={{ backgroundColor: "black" }}
  //             />
  //           </Box>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Establishment Unique Number
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 disabled
  //                 fullWidth
  //                 name="establishmentid"
  //                 value={formData.establishmentid}
  //                 onChange={handleChange}
  //                 size="small"
  //                 // style={{ height: "20px" }}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Establishment Number
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 name="establishmentnumber"
  //                 value={formData.establishmentnumber}
  //                 onChange={handleChange}
  //                 size="small"
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Establishment Description
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 name="establishmentdescription"
  //                 value={formData.establishmentdescription}
  //                 onChange={handleChange}
  //                 size="small"
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Website
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="website"
  //                 value={formData.website}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Email Id
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="emailid"
  //                 value={formData.emailid}
  //                 onChange={handleChange}
  //                 error={errors.emailid} // Show error style if true
  //                 helperText={errors.emailid ? "Email ID is required" : ""}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Phone Number
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 name="ephonenumber"
  //                 value={formData.ephonenumber}
  //                 size="small"
  //                 onChange={handleChange}
  //                 error={errors.ephonenumber} // Show error style if true
  //                 helperText={
  //                   errors.ephonenumber ? "Phone Number is required" : ""
  //                 }
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Address
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 size="small"
  //                 fullWidth
  //                 name="address1"
  //                 value={formData.address1}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 City
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="city"
  //                 value={formData.city}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 State
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="state"
  //                 value={formData.state}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Pincode
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="pincode"
  //                 value={formData.pincode}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Contact Person Name
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="contactpersonname"
  //                 value={formData.contactpersonname}
  //                 onChange={handleChange}
  //                 error={errors.contactpersonname} // Show error style if true
  //                 helperText={
  //                   errors.contactpersonname
  //                     ? "Contact Person Name is required"
  //                     : ""
  //                 }
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Contact Person Email
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="contactpersonemailid"
  //                 value={formData.contactpersonemailid}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Industry Type
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="industrytype"
  //                 value={formData.industrytype}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Registration Date
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <LocalizationProvider dateAdapter={AdapterDayjs}>
  //                 <DatePicker
  //                   value={formData.registrationdate}
  //                   onChange={handleDateChange}
  //                   renderInput={(startProps, endProps) => (
  //                     <>
  //                       <TextField
  //                         {...startProps}
  //                         fullWidth
  //                         size="small"
  //                         helperText={
  //                           errors.registrationdate
  //                             ? "Registration Date is required"
  //                             : ""
  //                         }
  //                       />
  //                     </>
  //                   )}
  //                 />
  //               </LocalizationProvider>
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Amount Paid
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="amountpaid"
  //                 value={formData.amountpaid}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           lg={4}
  //           md={4}
  //           sm={12}
  //         >
  //           <Grid
  //             container
  //             alignItems="center"
  //           >
  //             <Grid
  //               item
  //               xs={4}
  //               style={{ textAlign: "left" }}
  //             >
  //               <Typography
  //                 variant="subtitle1"
  //                 style={{ fontSize: "14px" }}
  //               >
  //                 Payment Details
  //               </Typography>
  //             </Grid>
  //             <Grid
  //               item
  //               xs={8}
  //             >
  //               <TextField
  //                 fullWidth
  //                 size="small"
  //                 name="paymentdetails"
  //                 value={formData.paymentdetails}
  //                 onChange={handleChange}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>

  //         <Grid
  //           item
  //           xs={12}
  //           className="mt-5"
  //         >
  //           <Button
  //             variant="contained"
  //             color="primary"
  //             type="submit"
  //           >
  //             Submit
  //           </Button>
  //         </Grid>
  //       </Grid>
  //     </form>
  //     {/* Success Snackbar */}
  //     <Snackbar
  //       anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
  //       open={openSuccess}
  //       autoHideDuration={3000}
  //       onClose={handleSuccessClose}
  //       message={successMessage}
  //     />
  //   </>
  // );
  return (
    <>
      <Helmet>
        <title>
          ContactTab - Establishment Registration: : a hassle-free way for
          businesses to sign up and seamlessly integrate with our contactTab
          software for streamlined lead tracking. Simplify your journey to
          effective lead management—sign up today and start maximizing your
          business potential!
        </title>
      </Helmet>
      <form onSubmit={handleSubmit}>
        <Grid
          container
          spacing={3}
        >
          {/* Establishment Registration Heading */}
          <Grid
            container
            item
            xs={12}
          >
            <Grid
              item
              xs={8}
            >
              <Typography
                variant="h5"
                align="left"
              >
                Establishment Registration
              </Typography>
            </Grid>
            {/* <Grid
              item
              xs={4}
              className="text-end"
            >
              <EditIcon />
            </Grid> */}
          </Grid>

          {/* Establishment Details */}
          <Grid
            item
            xs={12}
            // className="mt-3"
          >
            <Typography align="left">Establishment Details</Typography>
          </Grid>
          {/* Divider line */}
          <Grid
            item
            xs={12}
          >
            <Box>
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "black" }}
              />
            </Box>
          </Grid>
          {/* -----------input fields---------------------------------------- */}
          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "16px" }}
                >
                  Establishment Unique Number
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  disabled
                  fullWidth
                  name="establishmentid"
                  value={formData.establishmentid}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Establishment Number
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="establishmentnumber"
                  value={formData.establishmentnumber}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Establishment Description
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="establishmentdescription"
                  value={formData.establishmentdescription}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Website
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          {/* ----------------Contact Details ---------------- */}
          <Grid
            item
            xs={12}
            // className="pt-5"
          >
            <Typography align="left">Contact Details</Typography>
          </Grid>
          {/* Divider line */}
          <Grid
            item
            xs={12}
          >
            <Box>
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "black" }}
              />
            </Box>
          </Grid>
          {/* -----------input fields---------------------------------------- */}
          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Email Id
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="emailid"
                  value={formData.emailid}
                  onChange={handleChange}
                  error={errors.emailid} // Show error style if true
                  helperText={errors.emailid ? "Email ID is required" : ""}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Phone Number
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="ephonenumber"
                  value={formData.ephonenumber}
                  size="small"
                  onChange={handleChange}
                  error={errors.ephonenumber} // Show error style if true
                  helperText={
                    errors.ephonenumber ? "Phone Number is required" : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Address
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  size="small"
                  fullWidth
                  name="address1"
                  value={formData.address1}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  City
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  State
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Pincode
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Contact Person Name
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="contactpersonname"
                  value={formData.contactpersonname}
                  onChange={handleChange}
                  error={errors.contactpersonname} // Show error style if true
                  helperText={
                    errors.contactpersonname
                      ? "Contact Person Name is required"
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Contact Person E-Mail
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="contactpersonemailid"
                  value={formData.contactpersonemailid}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* -----------License Details --------------*/}
          <Grid
            item
            xs={12}
            // className="pt-5 mt-4"
          >
            <Typography align="left">License Details</Typography>
          </Grid>
          {/* Divider line */}
          <Grid
            item
            xs={12}
          >
            <Box>
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "black" }}
              />
            </Box>
          </Grid>
          {/* -----------input fields---------------------------------------- */}
          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Industry Type
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="industrytype"
                  value={formData.industrytype}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Registration Date Field */}
          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Registration Date
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={formData.registrationdate}
                    onChange={handleDateChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Amount Paid
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  size="small"
                  name="amountpaid"
                  value={formData.amountpaid}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
            className=""
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={4}
                style={{ textAlign: "left" }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontSize: "14px" }}
                >
                  Payment Details
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  size="small"
                  fullWidth
                  name="paymentdetails"
                  value={formData.paymentdetails}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className=" mt-5"
          >
            <Button
              variant="contained"
              color="primary"
              type="submit"
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
      {/* Success Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSuccess}
        autoHideDuration={3000}
        onClose={handleSuccessClose}
        message={successMessage}
      />
    </>
  );
};

export default CompanyRegistrationForm;
